import { Axios, AxiosInstance, default as axios } from 'axios'

/**
 * A service class for making API requests with a master key using Axios.
 * This is utility to control that MasterAxios instance is instantiated correctly.
 */
export class MasterAxiosService {
  /**
   * The Axios instance used for making HTTP requests.
   * @type {AxiosInstance}
   */
  public axios: AxiosInstance

  /**
   * Creates an instance of MasterAxiosService.
   * @param {string} [baseUrl] - The base URL for the API requests.
   * @param {string} [masterKey] - The master key for authorization.
   * @throws {Error} If the base URL is not provided.
   * @throws {Error} If the master key is not provided.
   */
  constructor(baseUrl?: string, masterKey?: string) {
    if (!baseUrl) throw new Error('Base URL is required')
    if (!masterKey) throw new Error('Master Key is required')
    this.axios = axios.create({
      baseURL: baseUrl,
      headers: {
        common: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${masterKey}`,
        },
      },
    })
  }
}

/**
 * A service class for making API requests with Single Sign-On (SSO) using Axios.
 * This is utility to control that SSOAxios instance is instantiated correctly.
 * The SSO service doesn't need any authorization headers.
 */
export class SSOAxiosService {
  /**
   * The Axios instance used for making HTTP requests.
   * @type {AxiosInstance}
   */
  public axios: AxiosInstance
  public interceptors: Axios['interceptors'] | null = null

  /**
   * Creates an instance of SSOAxiosService.
   * @param {string} [baseUrl] - The base URL for the API requests.
   * @throws {Error} If the base URL is not provided.
   */
  constructor(baseUrl?: string) {
    if (!baseUrl) throw new Error('Base URL is required')
    this.axios = axios.create({
      baseURL: baseUrl,
      headers: {
        common: {
          'Content-Type': 'application/json',
        },
      },
    })

    this.interceptors?.request.use(
      (config) => {
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )

    this.interceptors?.response.use(
      (response) => {
        return response
      },
      (error) => {
        return Promise.reject(error)
      }
    )
  }
}
